export default __webpack_public_path__ + "static/media/mouse.906c2eb4.svg";